import { defineStore } from 'pinia'
import type { TAssistantCpnProps } from '../types'
import { EAuthority, EIntelligentType } from '../constant'
import type { PreQuestionConfig } from './asst-store'
import { asstStore } from './asst-store'

export interface IOpenCommon {
  findFileInfo?: TAssistantCpnProps['findFileInfo'] | null
  preQuestionConfig?: PreQuestionConfig | null
  prePrompt?: string | null
}

export const drawAsstV2Store = defineStore('drawAsstV2', () => {
  const showDraw = ref<boolean>(false)
  const placement = ref<'top' | 'right' | 'bottom' | 'left'>('right')
  const width = ref<number>(600)

  const cpnProps = ref<TAssistantCpnProps>()
  function openCommon(config?: IOpenCommon) {
    const props: TAssistantCpnProps = {
      type: EIntelligentType.GLOBAL,
      authority: EAuthority.ASSISTANT + EAuthority.HISTORY + EAuthority.LANGUAGE,
      findFileInfo: config?.findFileInfo || null,
      preQuestionConfig: config?.preQuestionConfig || null,
      prePrompt: config?.prePrompt || null,
    }
    if (config?.knowledgeBaseId) {
      props.knowledgeBaseId = config.knowledgeBaseId
    }

    cpnProps.value = props
    showDraw.value = true
  }

  function openFile(fileID: number, fileName: string) {
    const props: TAssistantCpnProps = {
      type: EIntelligentType.FILE,
      fileID,
      fileName,
    }
    cpnProps.value = props
    showDraw.value = true
  }

  const afterLeaveFn = () => {
    console.log('000')
    const assistantStore = asstStore()

    assistantStore.reset()
  }

  return {
    openCommon,
    afterLeaveFn,
    openFile,
    showDraw,
    placement,
    width,
    cpnProps,
  }
})
